import {apiClient} from "@common/http/query-client";
import {useMutation} from "@tanstack/react-query";

interface Payload {
  userId: number,
  pin?: string
}

export function useDownloadWishesPdf() {
  return useMutation({
    mutationFn: (payload: Payload) => downloadWishesPdf(payload),
  });
}

function downloadWishesPdf(payload: Payload): Promise<void> {
  return apiClient
    .get(`users/${payload.userId}/download-wishes-pdf`, {
      responseType: "blob",
      headers: {
        "X-Pin": payload.pin ?? "",
      },
    })
    .then(async (response) => {
      const contentType = response.headers["content-type"];

      if (!contentType.includes("pdf")) {
        // Convert response to text and log it
        const text = await response.data.text();
        console.error("Unexpected response (not a PDF):", text);
        return;
      }

      // If it's a PDF, process it
      const blob = new Blob([response.data], {type: "application/pdf"});
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "wishes.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Download failed:", error);
    });
}
